//
// Module for the Insurance Index view
//
rs.module("content/participant/benefit/insurance/index",

    [
        "controls/data/grid"
    ],

    function (gridModule) {

        // Initialize the module
        function initialize(lrsGridApi, jsSelectors, backendUrl) {

            var filter = $.js(jsSelectors.filter);

            var filterIndicators = filter.js(jsSelectors.filterIndicators);
            var loadingSpinner = filter.js(jsSelectors.loadingSpinner);

            var addButton = $.js(jsSelectors.addButton);

            // Hook up click event on the radio buttons to reload the grid data via ajax
            filterIndicators.find("input").on('click', function () {

                loadingSpinner.show();

                // Update grid
                gridModule.update(
                    backendUrl,
                    { showAll: this.value },
                    lrsGridApi.agGridApi,
                    function done(gridUpdate) {
                        loadingSpinner.hide();

                        // Update the Add button url to include the current selection
                        addButton.attr('href', gridUpdate.context.addUrl);
                    }
                );
            });
        }

        // Exported public API
        var exports = {
            initialize: initialize
        };

        return exports;
    }
);